import { useState, useEffect, useRef } from 'react';
import './chat.css';
import emea from '../../img/bissole.png';
import powered from '../../img/logo.png';
import { FaRegPaperPlane, FaArrowDown } from 'react-icons/fa';
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import Message from './message';
import { DEMOCHAT_CHAT_URL, getDemochatAuthHeaders } from '../../apiConfig';

function Chat({ contextRef, onConversationChange, onInFlightChange }) {
  const [content, setContent] = useState([]);
  const [singleMessage, setSingleMessage] = useState('');
  const [blockButton, setBlockButton] = useState(false);
  const [actualIndex, setActualIndex] = useState(0);
  const [actualMessage, setActualMessage] = useState('');

  const localContextRef = useRef([]);
  const fullContext = contextRef ?? localContextRef;
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);

  // Funkcja przewijania na dół
  const scrollToBottom = (smooth = true) => {
    messagesEndRef.current?.scrollIntoView({
      behavior: smooth ? "smooth" : "auto",
    });
  };

  // Nasłuchiwanie scrolla — sprawdza, czy użytkownik jest na dole
  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const threshold = 50;
      const atBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight <
        threshold;
      setIsAtBottom(atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  // Przewijanie tylko, jeśli użytkownik jest na dole
  useEffect(() => {
    if (isAtBottom) {
      scrollToBottom();
    }
  }, [content, fullContext, actualMessage, isAtBottom]);

  // Wysyłanie wiadomości
  const submitMessage = async () => {
    if (singleMessage === '') return;

    try {
      setActualMessage('');

      let singleJsonMessage = {
        role: 'user',
        content: singleMessage,
      };
      fullContext.current.push(singleJsonMessage);
      onConversationChange?.();

      setContent((oldArray) => [
        ...oldArray,
        { id: actualIndex, message: singleMessage, who: 'User' },
      ]);
      setActualIndex((prev) => prev + 1);
      setSingleMessage('');

      const requestOptions = {
        method: 'POST',
        headers: getDemochatAuthHeaders(),
        body: JSON.stringify(fullContext.current),
      };

      setContent((oldArray) => [
        ...oldArray,
        { id: actualIndex, message: '', who: 'AI' },
      ]);

      let response = await fetch(
        DEMOCHAT_CHAT_URL,
        //'http://127.0.0.1:8000',
        requestOptions
      );
      const reader = response.body
        .pipeThrough(new TextDecoderStream('utf-8'))
        .getReader();
      setBlockButton(true);
      onInFlightChange?.(true);

      try {
        let fullAnswer = '';
        while (true) {
          const { value, done } = await reader.read();
          if (done) {
            setBlockButton(false);
            singleJsonMessage = { role: 'assistant', content: fullAnswer };
            fullContext.current.push(singleJsonMessage);
            onConversationChange?.();
            break;
          }
          setActualMessage((prev) => prev + value);
          setContent((prevItems) => {
            const newItems = [...prevItems];
            newItems[newItems.length - 1] = {
              id: actualIndex,
              message: newItems[newItems.length - 1].message + value,
              who: 'AI',
            };
            return newItems;
          });
          fullAnswer += value;
        }
      } finally {
        onInFlightChange?.(false);
      }
    } catch (e) {
      onInFlightChange?.(false);
      console.error(e.message);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !blockButton) {
      submitMessage();
    }
  };

  return (
    <>
      <div className='container'>
        <div className='logo__container--right'>
          <a target="_blank" rel="noopener noreferrer" href="https://bissole.pl/">
            <img src={emea} alt="emea" className='logo__img_bissole' />
          </a>
        </div>
        <div className='container__padding'>
          <div className='container_content' ref={chatContainerRef}>
            {content.map((elem) => (
              <Message
                key={elem.id + elem.who}
                message={elem.message}
                who={elem.who}
                smooth={true}
              />
            ))}
            <div ref={messagesEndRef} />
          </div>

          {/* 🔽 Przycisk powrotu na dół */}
          {!isAtBottom && (
            <button
              className='scrollToBottomBtn'
              onClick={() => {
                scrollToBottom();
                setIsAtBottom(true);
              }}
            >
              <FaArrowDown />
            </button>
          )}

          <div className='container__input'>
            <div className='container--mobile'>
              <input
                className='message__input'
                placeholder='Co możemy zrobić dla Twojej firmy?'
                onChange={(e) => setSingleMessage(e.target.value)}
                onKeyDown={handleKeyDown}
                value={singleMessage}
              />
              <button
                onClick={() => submitMessage()}
                className='message__submitButton'
                disabled={blockButton}
              >
                <FaRegPaperPlane />
              </button>
            </div>
            <div className='container--mobile'>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href='https://www.datacourage.com/'
              >
                <img src={powered} alt="dataCourage" className='logo__img' />
              </a>
            </div>
          </div>
        </div>
        {/*<div className='footer'>BETA VERSION</div>*/}
      </div>
    </>
  );
}

export default Chat;